import { render, staticRenderFns } from "./contractCreator.vue?vue&type=template&id=2bbf8534&scoped=true"
import script from "./contractCreator.vue?vue&type=script&lang=js"
export * from "./contractCreator.vue?vue&type=script&lang=js"
import style0 from "./contractCreator.vue?vue&type=style&index=0&id=2bbf8534&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bbf8534",
  null
  
)

export default component.exports